import CoursePlanReducer from './CoursePlanReducer';
export default CoursePlanReducer;
